import { JSX } from "react";

const ProvidersByZipCodeClassificationDescription = (): JSX.Element => {
  return <>
    <p>
      The Providers By Zip Code Classification card summarizes how your network is spread across different Zip Code classifications. Zip Code Classifications play an important role in determining the adequacy standards for the geographic area and are determined by the project template. 
    </p>
    <p>
      Providers located in a Zip Code without a valid classification in the template will be grouped as “Unclassified.” For example, Canadian postal codes not defined by the US Census zip code definitions would come back with an “Unclassified” designation.
    </p>
  </>;
}

export { ProvidersByZipCodeClassificationDescription };